import PropTypes from "prop-types"
import { map } from "lodash"
import LogoHomeLink from "components/logo/home-link"
import ServerNotifications from "modules/server-notifications"
import { LINK, PORTFOLIO } from "../../shapes"
import MobileNav from "../mobile-nav"
import PortfolioSelector from "../portfolio-selector"
import HelpMenu from "modules/help-menu"
import ThemeModeToggle from "components/theme-mode-toggle"
import ContextualMenu from "components/contextual-menu"
import { KellyLauncherButton } from "connected-components/agent-chat/components/kelly-launcher-button"
import { useSaveContextPreferences } from "hooks/preferences"
import PortfolioNavLink from "./portfolio-nav-link"
import ActiveNavLabel from "./active-nav-label"

import "./style.scss"

export default function Nav({ account, portfolioName, isLoading, links, latestPortfolios, modelId, navigationDisabled, menuItems }) {
  const saveLastLocationPreference = useSaveContextPreferences("navigation.root")

  return <div className="nav">
    {!navigationDisabled && <div className="left">
      <MobileNav links={links} portfolioName={portfolioName} isLoading={isLoading} home={`/${account}/home`} menuItems={menuItems} />
      <LogoHomeLink account={account} />
      <PortfolioSelector
        portfolioName={portfolioName}
        isLoading={isLoading}
        latestPortfolios={latestPortfolios}
        trailingActions={<ContextualMenu items={menuItems} />}
      />
      {map(links, link =>
        <PortfolioNavLink key={link.id} link={link} onSaveLastLocation={saveLastLocationPreference} />,
      )}
    </div>}
    {/* Carries the row's hairline, holds the buttons right when nav is disabled, and names the
        page below `md` where the tabs are hidden. */}
    <div className="filler">
      {!navigationDisabled && map(links, link => <ActiveNavLabel key={link.id} link={link} />)}
    </div>
    <div className="right">
      <div className="ai-button-spacer" />
      <ServerNotifications />
      <HelpMenu modelId={modelId} />
      <ThemeModeToggle inline />
      <KellyLauncherButton />
    </div>
  </div>
}

Nav.propTypes = {
  account: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(LINK).isRequired,
  portfolioName: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  modelId: PropTypes.string,
  latestPortfolios: PropTypes.arrayOf(PORTFOLIO).isRequired,
  navigationDisabled: PropTypes.bool.isRequired,
  menuItems: PropTypes.array,
}
